import React from "react"
const RepeatEvaluation = ({style = {}, size = "36", className = "", fill="#4E525F", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="m16.35 7-4.76 4.568 4.76 4.612v-2.845h9.64c2.726 0 4.935 2.255 4.935 4.98 0 2.676-2.169 4.89-4.845 4.89v3.62a7.92 7.92 0 0 0 7.92-7.92v-.613a8.533 8.533 0 0 0-8.533-8.534H16.35V7Z"
        />
        <path
            fill={fill}
            d="m19.65 29.41 4.76-4.568-4.76-4.611v2.844h-9.64c-2.726 0-4.935-2.255-4.935-4.98 0-2.675 2.169-4.889 4.844-4.889v-3.62A7.92 7.92 0 0 0 2 17.506v.613a8.533 8.533 0 0 0 8.534 8.533h9.118v2.759Z"
        />
    </svg>
)
export default RepeatEvaluation